<template>
  <el-dialog
    :visible="isCustomersModalActive"
    :before-close="beforeClose"
    append-to-body
    fullscreen
    @open="onOpen"
    @close="onClose"
  >
    <div
      class="layout__position-center text__align-center"
    >
      <el-alert
        v-if="errorMessage || customersErrorMessage"
        :title="errorMessage || customersErrorMessage"
        type="error"
        show-icon
        style="position: fixed; top: 0; left: 0; z-index: 2004;"
        @close="() => { $emit('clear-error-message'); customersErrorMessage = '' }"
      />

      <h3 class="text__colour-teal mb-20">
        Voucher Customers
      </h3>

      <div>
        <div class="d-flex align-center mb-20">
          <el-input
            v-model="searchTerm"
            :disabled="isLoading || isSearching"
            placeholder="Search customers (min 3 symbols)"
          />

          <el-button
            class="ml-10 button__background-red-border button__base"
            :disabled="isLoading || isSearching"
            @click.prevent="searchCustomers"
          >
            Search
          </el-button>
        </div>

        <div class="d-flex justify-center align-center mb-20">
          Customers selected: {{ voucherData.Customers ? voucherData.Customers.length : 0 }}
          <el-button
            class="ml-10 button__background-red-border button__base"
            :disabled="isLoading"
            @click.prevent="voucherData.Customers = []"
          >
            Reset selected
          </el-button>
        </div>

        <div
          v-if="voucherData.Customers && voucherData.Customers.length"
          class="mb-20 text__align-left"
        >
          <b>Selected customer refs: </b> {{ voucherData.Customers.join(', ') }}
        </div>

        <el-form
          :model="voucherData"
          class="products-form mb-20"
        >
          <el-form-item prop="Products">
            <el-checkbox-group v-model="voucherData.Customers">
              <el-checkbox
                class="text__direction-left-to-right product-checkbox"
                v-for="customer in customersList"
                :key="customer.ref"
                :label="customer.ref"
              >
                <b>Ref: </b> {{ customer.ref }}
                <b>Customer: </b> {{ customer.customer }}
                <template
                  v-if="customer.parent_ref"
                >
                  <b>Parent ref: </b> {{ customer.parent_ref }}
                </template>
                <template
                  v-if="customer.brand"
                >
                  <b>Brand: </b> {{ customer.brand }}
                </template>
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>

        <div
          class="d-flex layout__width-100 justify-center"
        >
          <el-button
            class="button__background-red-border button__base"
            :disabled="isLoading"
            @click.prevent="save"
          >
            Save
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import VoucherApi from '../../../Api/Voucher';
import Customer from '../../../Models/Customer';
import Voucher from '../../../Models/Voucher';

export default {
  name: 'CustomersModal',

  props: {
    isCustomersModalActive: {
      type: Boolean,
      required: true,
    },

    editableItem: {
      type: Object | null,
      required: true,
    },

    isLoading: {
      type: Boolean,
      required: true,
    },

    errorMessage: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      voucherData: {},
      searchTerm: '',
      isSearching: false,
      customersList: [],
      customersErrorMessage: '',
    };
  },

  methods: {
    onOpen() {
      this.voucherData = this.editableItem
        ? Voucher.make({ ...this.editableItem })
        : {};
    },

    beforeClose() {
      this.customersList = [];
      this.searchTerm = '';
      this.customersErrorMessage = '';
      this.isSearching = false;

      this.$emit('on-closed');
    },

    onClose() {
      this.customersList = [];
      this.searchTerm = '';
      this.customersErrorMessage = '';
      this.isSearching = false;
    },

    async searchCustomers() {
      if (this.searchTerm.length < 3) {
        return;
      }

      this.isSearching = true;

      let response;

      try {
        response = await VoucherApi.customersList({ search: this.searchTerm });

        if (response.data.error) {
          this.customersErrorMessage = 'Error while customers search';

          return;
        }

        this.customersList = response.data.map(customer => Customer.make(customer));
      } catch {
        this.customersErrorMessage = 'Error while customers search';
      }

      this.isSearching = false;
    },

    save() {
      this.$emit('save-customers', this.voucherData);
    },
  },
};
</script>
